import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { BaseChordDisplayModel } from '@jbrowse/plugin-circular-view';
import { ConfigurationReference } from '@jbrowse/core/configuration';
import { types } from 'mobx-state-tree';
import { getContainingView } from '@jbrowse/core/util';
import { getParentRenderProps } from '@jbrowse/core/util/tracks';
/**
 * #stateModel ChordVariantDisplay
 * extends `BaseChordDisplay`
 */
var stateModelFactory = function stateModelFactory(configSchema) {
  return types.compose('ChordVariantDisplay', BaseChordDisplayModel, types.model({
    /**
     * #property
     */
    type: types.literal('ChordVariantDisplay'),
    /**
     * #property
     */
    configuration: ConfigurationReference(configSchema)
  })).views(function (self) {
    return {
      /**
       * #getter
       */
      get rendererTypeName() {
        return self.configuration.renderer.type;
      },
      /**
       * #method
       */
      renderProps: function renderProps() {
        var view = getContainingView(self);
        return _objectSpread({}, getParentRenderProps(self), {
          rpcDriverName: self.rpcDriverName,
          displayModel: self,
          bezierRadius: view.radiusPx * self.bezierRadiusRatio,
          radius: view.radiusPx,
          blockDefinitions: self.blockDefinitions,
          config: self.configuration.renderer,
          onChordClick: self.onChordClick
        });
      }
    };
  });
};
// http://localhost:3000/test_data/hs37d5.HG002-SequelII-CCS.sv.vcf.gz.tbi
// render request is for 1.5x the current viewing window
// tracks all have a height
//
export default stateModelFactory;